import Svg from '@doordash/component-svg'
import * as React from 'react'

// tslint:disable:max-line-length
export const PickupAndDropoff: React.FunctionComponent = () => (
  <Svg
    width={289}
    height={251}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      d="M2.747 160.199c6.2-19.9 36.9-54.7 21.1-71.4-38.2-40.4-20.4-82.7 38.2-77.5 10.6.9 20.6 4.7 29.8 10.4 43.9 27.2 96.4-50.6 136.4-9.4 38.9 40.1-14.3 67.3 27.3 77.8 58.6 17.4 26.8 140.8.2 159.4-58.3-.4-116.5.9-164.5-.4-17.9-1.4-108-25.6-88.5-88.9z"
      fill="#E5F3F7"
    />
    <path
      d="M112.647 170.999c3.9.7 6.9-2.3 10.5-2.7 4.3-.5 6.3-.1 7.8-.3 1.5-.2 3.4-.6 3.2-1.8-.2-1.3-1.6-1.6-2.6-1.6-1.7 0-5.3-.2-5.3-.6 0-.2 7.5-.1 8.7-.1 1.2 0 2.3.2 3.4-.1 1.1-.2 1.8-.9 1.6-1.6-.2-.7-.4-1.3-1.7-1.6 1.2-.2 2.7-.3 3.4-.5.7-.2 1.5-1 1.2-1.7-.3-.8-1.3-1.5-2.3-1.6-1-.1-4.2-.5-5.6-.5-1.4-.1-3.5-.6-3.5-.6s6.7-.4 7.8-.5c1.2-.1 2-.7 1.8-1.6-.2-.9-1.4-1.7-3.5-1.7s-13.4.7-17.1 1.6c-5 1.2-6.2 3.5-13.3 7.6-.2 10.2 5.5 9.9 5.5 9.9z"
      fill="#A48774"
    />
    <path
      d="M138.347 160.399v.1c-4.8-1-11-.5-11.1-.5v-.6c0 .1 6.2 0 11.1 1zm-87.5 20.2c8.1-2.9 15.4-4.7 19-5.7 10.6-2.8 22.7-5.4 32-10.8 7.3-4.2 10.6-5.6 12.2-6.9 1.1-.9 5.4-1 8.6 3.6 1.1 1.6 2.4 3.7.8 5.8-1.9 2.4-7.9 3.6-9.4 4.4-3.5 1.8-1.1.6-12 7.1-11 6.6-24.6 15.5-45.4 22.5-1.5.5-4.6-.3-4.6-.3s-4.2-3.6-5.9-6.4c-2.5-4.1-3.6-10.1-3.6-10.1l8.3-3.2z"
      fill="#A48774"
    />
    <path
      d="M64.447 121c1 .7 4.2 5.7 11.5 4.6 9-1.3 14.6-8 14.4-15.4-.2-6.9-2.1-9.7-1-13.4 1-3.7 5.2-17.2 5.2-17.2s-3.4-9.9-7.1-10.4c-3.7-.6-4 2.2-4 2.2l-.3 4.4s4.1 3.4 3.5 8.5c-.7 5.1-3.5 21-6.6 22.4-3.1 1.4-11.7 1.9-11.7 1.9l-3.9 12.4z"
      fill="#28362C"
    />
    <path d="M256.747 249.2l4.1-14.2-60.9-1.2-1.6 15.4h58.4z" fill="#A6C7CE" />
    <path
      d="M239.947 188.7c5.9 4.3 4.3 9 1.1 12.7-3.2 3.6-18.5 2.2-18.5 2.2l-23.8-11.2s-10-7.4-15.7-11c-1.6-1-10.1-7.1-14.1-8.5-4-1.4 11.8-9.1 15.5-7 4.7 2.7 31.8 10 37.3 12.8 5.3 2.8 17 9.1 18.2 10z"
      fill="#806957"
    />
    <path
      d="M228.147 93c.6-.3 1.2-.2 1.7.3 3.6 3.4 22.5 20.099 23.9 23.799 4 10.1 8.4 31.9 10.1 41.4 1.7 9.5-1.4 77-1.4 77l-43.2 1.6s-23.8-12.2-24.7-12.8c-2.8-1.8 1.6-63.7 1.5-71.6 0-7.9 4.7-29.2 6-34.9 1.3-5.7 7.8-13.4 7.8-13.4l18.3-11.4z"
      fill="#fff"
    />
    <path
      d="M211.847 131.299l-2-.8c.1-1.4 1.4-13.8 3.5-16.6 3.7-4.8 20.7-13.8 22.8-15.1l2 2.2c-6.2 3.1-17.1 9.3-22.2 14.2-1.2 1.3-3.7 12.4-4.1 16.1z"
      fill="#63796D"
    />
    <path
      d="M200.247 125.399l16.2 7.8 22.2 101.2 1.2 14.8h-46l-.1-21.1.5-58.8 2.4-33.1c0-.1 2.7-9.8 3.6-10.8z"
      fill="#3C5749"
    />
    <path
      d="M210.547 194.299s13-48.2 17.5-56.1c4.6-7.9 16.2-7.5 21.7-4.5 5.6 3-4.7 67.6-16.8 76.6-4.4 3.3-22.4-16-22.4-16z"
      fill="#806957"
    />
    <path
      d="M257.047 168.799l-44.5 2.7s2-37.4 4.1-43c2.1-5.6 12.9-9.1 14-9.4l24.5 9.3 1.9 40.4z"
      fill="#fff"
    />
    <path
      d="M258.647 170.2s-2.6-38.7-5.9-44c-3.3-5.4-21.5-7.7-21.5-7.7-1.2.3-12.4 4-14.6 9.8l-.8 4.2"
      stroke="#E1E0D8"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      d="M155.147 157.8c.3 1.3 3.5 8.6 3.8 8.5.8-.2 3.6-.1 3.5-.3-.1-.2-.9-2.4-1.8-3.9s-1.4-2.7-2.3-3.6c-1-1.1-1.5-1.3-2.3-1.2-.7.1-.9.5-.9.5zm-4.8.899c-.2.6 3 7.4 3.4 7.8.4.4 1.1.3 2.2.4 1.1.1 1.8-.7 1.8-.7s-.6-.9-1.3-2.3c-.9-1.8-1.4-2.8-2.3-3.9-.9-1.1-1-1.1-1.9-1.5-.8-.3-1.8 0-1.9.2zm-4.5 2.901c.8 1.4 3 5.2 3 5.2s1.2.6 2.4.8c1.2.2 2.4 0 2.3-.4-.1-.4-.7-1.9-.7-1.9l-2.7-3.3s-1-1.6-1.7-2.3c-.7-.7-1-.8-1.6-1-.6-.2-1.4-.1-1.8.3-.3.3.8 2.6.8 2.6z"
      fill="#755A4B"
    />
    <path
      d="M138.347 161.1c.1.4 6.4 9.5 10.4 11.6 5.6 2.9 26.8.1 26.8.1l9.4-6.5s-8.2-6.7-10.3-7.6c-2.1-.9-6.9-2.1-7.9-2.5-.9-.4-10-5.5-10.3-5.3-.3.2-1.6 1.4-.3 3s7.6 6 7.8 6.7c.3.7-1.5 3.1-2.2 3.6-.8.5-12.1 1.5-12.7 1-.6-.5-6-5.1-7-5.5-2.5-1.2-3.8 1-3.7 1.4z"
      fill="#806957"
    />
    <path
      d="M171.347 171.799l6.3-9.9s-.9-2.3-3-3.2c-2.1-.9-6.9-2.1-7.9-2.5-.9-.4-8.8-5.4-9.9-5.4-1.4 0-2 3.7-.5 5.1 2.8 2.7 6.3 3.8 6.5 4.5.7 2.2-1.7 6.5-6.8 6.9l15.3 4.5z"
      fill="#806957"
    />
    <path
      d="M161.247 152.999c.4.3-.9.8-1.7.7-.8-.1-2.9-1.1-3.1-1.5-.2-.4-.3-.9.1-1.4.5-.4 3.6 1.5 4.7 2.2z"
      fill="#8F7868"
    />
    <path
      d="M132.747 150.7l.8 7.3 9.9-.3.9-7-1.8 2.6-2.1-3.3-1.5 2.4-1.7-2.3-2 2.6-2.5-2z"
      fill="#80B070"
    />
    <path
      d="M155.447 159.199c1.8-1 2.5-3.4 2-4.5s-1-2.5-3.5-3-6.4.3-6.8 1.1c-.4.8-1.3 4.3.8 5.6 2.6 1.5 5.8 1.6 7.5.8z"
      fill="#28362C"
    />
    <path
      d="M148.947 152.899c-1.4 1-1.9 3.1-1.3 4 .5.9 1 2.1 3.2 2.3 2.2.2 5.3-.8 5.6-1.5.3-.7.8-3.8-1.1-4.7-2.4-1.1-5.1-1-6.4-.1z"
      fill="#FAFAF7"
    />
    <path
      d="M152.347 156.999c.4.5 1.2-.3 1.4-.4.2-.1 1-.9.9-1.1-.1-.2-1.1-.9-1.1-.9s-.5.3-1.1.3c-.6 0-1.4-.1-1.7.2-.2.2.6 1 .8 1.4.2.4.6.3.8.5z"
      fill="#C3DEC1"
    />
    <path
      d="M149.847 154.899s-.7.7-.7 1c0 .3.5.9.5.9h1.1s.2-.7.4-1c.2-.3 1-1.2.5-1.3-.5-.2-1.8.4-1.8.4z"
      fill="#B8D3AF"
    />
    <path
      d="M140.547 156.299c0-.1.2-.5.6-1.1.4-.6.8-1.7 1.5-1.3.7.5 1.4 0 1.9.7s1 .9 1 1.6c.1.7.7.8 0 1.4-.7.6-1.1 1.4-2.2 1.5-1.1.1-2.4-.2-2.7-.7-.2-.6-.2-1.9-.1-2.1z"
      fill="#C7D285"
    />
    <path
      d="M155.447 152.099c-1.8 1-2.5 3.4-2 4.4.5 1.1 1 2.5 3.5 3s6.4-.3 6.8-1.1c.4-.8 1.3-4.3-.8-5.6-2.7-1.5-5.9-1.6-7.5-.7z"
      fill="#28362C"
    />
    <path
      d="M161.847 158.399c1.4-1 1.9-3.1 1.4-4-.5-.9-1-2.1-3.2-2.3-2.1-.3-5.3.8-5.6 1.4-.3.7-.8 3.8 1.1 4.7 2.3 1.2 5 1 6.3.2z"
      fill="#FAFAF7"
    />
    <path
      d="M158.547 154.099c-.4-.5-1.2.3-1.4.4-.2.1-1 .9-.9 1.1.1.2 1.1.9 1.1.9s.5-.3 1.1-.3c.6 0 1.4.1 1.7-.2.2-.2-.6-1-.8-1.4-.2-.4-.7-.3-.8-.5z"
      fill="#FF4F2D"
    />
    <path
      d="M161.047 156.4s.7-.7.7-1c0-.3-.5-.9-.5-.9h-1.1s-.2.7-.4 1c-.2.3-1 1.2-.5 1.3.5.1 1.8-.4 1.8-.4z"
      fill="#FF6F53"
    />
    <path
      d="M125.347 159.399c1.6.6 5-.4 6.2-.2 1.2.2 3.9.5 5.1 0 1.2-.5 1-1.1.5-3.9s-11.6-2-12.5-2c-.9-.3-.2 5.7.7 6.1z"
      fill="#FAFAF7"
    />
    <path
      d="M126.047 152.299c-1.7.1-2.2 1-2.1 1.8.1.5 0 1.7.4 2.3.4.5 1.4 1.2 2.3.7.9-.4 3.3-.5 6.1-.7 2.8-.2 4.9.7 5.3.4.4-.3.2-2.8-.8-3.4-2-1.2-4.3-.9-5.6-1-1.3-.1-5.6-.1-5.6-.1z"
      fill="#FF6F53"
    />
    <path
      d="M130.147 152.399c-.1.7-.5 7.1-.5 7.1l2.6-.1s.3-5.9.4-7h-2.5z"
      fill="#28362C"
    />
    <path
      d="M122.947 159.299c.2.4 1 2.3 1.6 2.4.7.1 39.5-.1 40.1-.3.6-.2 1.6-2.8 1.6-2.8l-43.3.7z"
      fill="#3C5749"
    />
    <path
      d="M118.847 157.999c.1.7.3 1.2.6 1.3.3.1 50.4.2 50.4-.4.1-.6.2-1.5-.1-1.6-.3.1-50.9.7-50.9.7z"
      fill="#3C5749"
    />
    <path
      d="M121.647 149.899c-.5.6-2 6-2.3 6.1-.4.1-1.3.9-1.4 1.2-.2.5 0 1.3.2 1.3s52.6.1 52.9-.4c.3-.6.2-1.4-.5-1.7-.8-.3-1.4-1.2-1.4-1.2s-.7-4.1-1.3-5.1c-.7-1-45.6-.8-46.2-.2z"
      fill="#fff"
      fillOpacity={0.61}
    />
    <path
      d="M177.747 54.1c.3 5.6 2.3 10.4 5.7 13.3 3.5 2.9 6.4.9 6.4.9l5.6-6.7 8.6-2.3s4.5 6.7 4 8.8c-.5 2.2 14.3 17.1 14.3 17.1s9.9-16 6.2-28.6c-2.6-8.9-10.5-14.8-15-14.9-4.4-.1-10.8 4.3-10.2 1.3.6-3.1-9.5-4.5-12.3-3.3-2.8 1.2-2.1 6.4-3.8 6.7-1.7.3-6.4-3-7.4-1.7-1 1.4-2.4 3.8-2.1 9.4z"
      fill="#28362C"
    />
    <path
      d="M191.447 40.2s-4.3 8.4 3.7 9.8c6.5 1.2 11.4-3 17.1-3.8 7.6-1.1 12.2 3 14.3 17.7m-43.5-16.5s-4.6 14 5.7 18.2"
      stroke="#3C5749"
      strokeWidth={0.466}
      strokeMiterlimit={10}
    />
    <path d="M214.047 67.1l-2.4-9.4-6.8 1.5 6.4 10 2.8-2.1z" fill="#28362C" />
    <path
      d="M223.147 84.5c.2-.6-3.7-8.4-3.6-9.4.5-4.5.8-7.3-.8-8.1-2.6-1.3-7.2 1.7-7.2 1.7s-5.4-9.3-7-9.9c-1.6-.6-13.5 4.2-13.5 4.2l-2.8 6s-1.1 16.6-.6 17.6c.5.9 3.7.7 3.7.7s4.2 10.4 5.1 11.4c.9.9 8.5-1.5 9.5-1.3 1 .2 5.3 13.099 5.3 13.099l20-14.4-8.1-11.6z"
      fill="#806957"
    />
    <path
      d="M219.447 75.1l-2.6 6.5s3.6 4.8 4.5 5.3c.8.5 3.8-7 4.7-9.7.7-2-6.6-2.1-6.6-2.1z"
      fill="#28362C"
    />
    <path d="M107.547 168.099l-3.2 82 73-.9-8.1-82.1-61.7 1z" fill="#FF4926" />
    <path
      d="M164.547 197.399h-48.3l2.6-27.8 4.5.2-2.3 23.1h38l-4.7-22.8 4.5-.8 5.7 28.1z"
      fill="#FF6446"
    />
    <path
      d="M90.547 249.599c-1.8-18.2-3.4-36.4-3.4-36.4l-30 11.6s.5 10.9 1 24.9l32.4-.1z"
      fill="#82BDC5"
    />
    <path
      d="M81.747 249.199c1.2-12.4 3.9-43 3.9-43l-37.7 3.8c-.9 4.8-3.7 10.4-8.4 16.8-4.2 5.8-7.6 14.4-8.2 22.8l50.4-.4z"
      fill="#AECCD2"
    />
    <path
      d="M85.547 206.399c-.2 3.2-2.3 32.3-2.3 32.3"
      stroke="#E2F3F7"
      strokeWidth={0.425}
      strokeMiterlimit={10}
    />
    <path
      d="M73.147 101.1c-2.7 4-1.3 21.3-1.3 21.3l1 6.6-12-2.3-11.2-6.7s5.1-4.4 6.1-9.1c3-14.2.5-22.8.6-24 .1-1.2 7.1 10 7.1 10l6.5 4.3 3.2-.1z"
      fill="#B39580"
    />
    <path
      d="M71.347 63.8c9.2-1.3 10.6 2.4 13.5 6.1 2.1 2.6 5.4 4.7 5.3 10.4-.1 3.7-1.2 8-.5 13.4.2 1.7 1.6 5.4 1.1 6-.3.3-.8.599-1.4.799-.4.1-1.6-.1-1.6-.1s-.3 2.1-.9 3.9c-.7 1.6-4 6.9-6.9 7.3-2.9.4-5.9-1-9.7-2.4-2.4-1.4-4.6-3.4-5.9-5.7-1.9-3.4-8-4.1-10.4-14.5-2.4-10.6.4-16.4 2.3-19.7 1.9-3.3 4.2-3.9 15.1-5.5z"
      fill="#BA9B83"
    />
    <path
      d="M78.047 121.699c-.7-.7-4.4-2.4-6.3-2.2.1.9.3 3-.2 3.1-10.2.6-22.4-4.5-22.4-4.5-6.1 1.4-14.6 18.1-15.1 19.8-1.6 5.3-.5 79.6 2.8 81.4 3.2 1.8 13.2 1.4 23.9-.3 13.3-2.1 29.1-2.8 33.6-12.8 1-2.2-1.1-24.3-5.5-48.2-3.5-18.5-5.4-31-10.8-36.3z"
      fill="#FF5534"
    />
    <path
      opacity={0.6}
      d="M85.647 206.199l-37.7 3.8c-.6 3.2-2 6.7-4.2 10.5 4.6.1 10.6-.5 17-1.5 9.9-1.6 19.2-2.6 24.2-4.6.4-4.9.7-8.2.7-8.2z"
      fill="#FF3008"
    />
    <path
      d="M108.447 185.1c3.9.7 6.9-2.3 10.5-2.7 4.3-.5 6.3-.1 7.8-.3 1.5-.2 3.4-.6 3.2-1.8-.2-1.3-1.6-1.6-2.6-1.6-1.7 0-5.3-.2-5.3-.6 0-.2 7.5-.1 8.7-.1 1.3 0 2.3.2 3.4-.1 1.1-.2 1.8-.9 1.6-1.6-.2-.7-.4-1.3-1.7-1.6 1.2-.2 2.7-.3 3.4-.5.7-.2 1.5-1 1.2-1.7-.3-.8-1.3-1.5-2.3-1.6-1-.1-4.2-.5-5.6-.5-1.4-.1-3.5-.6-3.5-.6s6.7-.4 7.8-.5c1.2-.1 2-.7 1.8-1.6-.2-.9-1.4-1.7-3.5-1.7s-13.4.7-17.1 1.6c-5 1.2-6.2 3.5-13.3 7.6-.3 10.2 5.5 9.9 5.5 9.9z"
      fill="#BA9B83"
    />
    <path
      d="M134.047 174.5v.1c-4.8-1-11-.5-11.1-.5v-.6c0 .1 6.3 0 11.1 1zm-97.4-24.701c.3 8 1 33.5 1.2 42.8 0 0-.2 16.4 10 16.1 9.9-.3 9-17 9-17-.1-6.2-.9-19.5-1.1-23.7-.3-7.6-.3-10-.3-15.5l-18.8-2.7z"
      fill="#BA9B83"
    />
    <path
      d="M46.547 194.699c8.1-2.9 15.4-4.7 19-5.7 10.6-2.8 22.7-5.4 32-10.8 7.3-4.2 10.6-5.6 12.2-6.9 1.1-.9 5.4-1 8.6 3.6 1.1 1.6 2.4 3.7.8 5.8-1.9 2.4-7.9 3.6-9.4 4.4-3.5 1.8-1.1.6-12 7.1-11 6.6-24.6 15.5-45.4 22.5-1.5.5-4.6-.3-4.6-.3s-4.2-3.6-5.9-6.4c-2.5-4.1-3.6-10.1-3.6-10.1l8.3-3.2z"
      fill="#BA9B83"
    />
    <path
      d="M35.847 149.999l23.9 3.3s2.2-14.4-2-22.7"
      stroke="#DA260D"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
    <path
      d="M223.647 203.299c7.3 0 20.2-16.5 18.9-11.8-6 21.3-17.3 27.9-17.3 27.9s-54.7 12.8-56.3 13.9c-1.6 1-4.8 4.9-8.8 6.2-4 1.3 1.1-20.7 5.3-21.2 5.4-.6 39.8-23.1 45.8-24.1 6.1-1 10.9 9.1 12.4 9.1z"
      fill="#806957"
    />
    <path
      d="M228.947 92.8c-.3 0-.6 0-.9.1l-18.2 11.399s-.2.3-.6.7c1 2.7 1.8 5.1 1.8 5.1l20-14.4-2.1-2.9z"
      fill="#E6E5D7"
    />
    <path
      d="M128.047 202.199c.5 1.2.3 1.9 1.2 2.9.9 1 1.5 1.6 2 1.6.6 0 4.1-.2 6.2-.2 2.1.1 3.8.1 3.9 1.1.2 1 .1 1.5-1.4 1.7-1.5.1-4.7-.2-5.3 0-.6.2-2.6-.1-1.7.9.9 1 2.9 3.4 3.5 3.4 1-.1 4.6 0 6 0 2.2-.1 4.2-3.7 4.1-5.5-.1-1.8-1.7-5-3.8-5.3-2.1-.3-8.1-.5-9.4-.5-1.3 0-5.3-.1-5.3-.1z"
      fill="#fff"
    />
    <path
      d="M171.647 232.799c-.7.4-2.4 1.4-3.2 2.2-1.5 1.4-2.9 2.1-4.6 3.6-1.7 1.5-5.9 4.1-7.8 4.6-1.9.5-11.4 3.1-13.4 3.6-2.1.4-2.6-.2-3.2-1.2-.6-1 .8-2 .8-2s-3.4 1-5.3 1.4c-1.9.4-3.3-1.1-3.4-2.3 0-.3.2-.6.6-.9-3 1-3.7-.4-4.2-1.6-.4-1.2 1.8-2.7 3.9-3.7 1.5-.7 8.2-3.2 10.1-4 1.9-.8 3.2-1.5 3.3-1.9.1-.4-.8-.6-2.1-.2-1.3.3-5.8 1.2-9 2-3.2.7-5.7.4-6.2-1-.5-1.3.8-2.1 2.2-2.8 1.3-.7 8.4-2.6 11.1-3.7 2.7-1.1 7.3-2 8.3-2.6 1.1-.6 1-1.4.8-1.7-.2-.2-3.3-1.3-4.6-1.9-1.3-.6-3.9-1.6-5.4-2.6-1.5-1-1.3-2.8-.3-3.6.9-.7 3.8.7 5.3.9 1.6.2 3.5-.1 7.3.5 2.8.5 5.8 2.4 10.1 4.1 1.2.5 2.6.8 5.6.1 0 0 1.4 1.2 2.8 7.2 1.5 5.9.5 7.5.5 7.5z"
      fill="#806957"
    />
    <path
      opacity={0.6}
      d="M72.847 128.999l-1-6.6s0-.4-.1-1c0 .6-.1 1.1-.3 1.1-7.8.5-16.8-2.4-20.6-3.8l-1.2 1.2 11.2 6.7 12 2.4z"
      fill="#FF3008"
    />
    <path
      d="M76.047 139.399c.2.6.1 1 .5 1.5s.6.8.8.8c.2 0 1.7-.2 2.5-.2s1.5 0 1.6.5c.1.5.1.8-.5.9-.6.1-1.9 0-2.1.1-.2.1-1.1 0-.7.5.4.5 1.2 1.8 1.5 1.8.4 0 1.9 0 2.4-.1.9-.1 1.7-2.1 1.6-3-.1-1-.8-2.7-1.6-2.8-.8-.1-3.3-.1-3.8-.1-.6 0-2.2.1-2.2.1z"
      fill="#fff"
    />
    <path
      d="M89.547 90.6s-1.7 8.5-6.6 8.1c-3.6-.2-3.6-5.9-3.4-8.3 0-.6.6-1 1.1-.9l10.9 1.4c.7.1 1.3.3 1.5.8.2.7-.8 6.3-2.3 6.7m-10.9-8.6l-13.5.3"
      stroke="#FF3008"
      strokeWidth={0.4}
      strokeMiterlimit={10}
    />
    <path
      d="M65.947 89.8s5 3.9 8.8-1.1c3.8-5 10.6-15.3 14.8-12.6 1.1.7-.1-5.5-.1-5.5s-4.8-11.5-19-11c-14.6.4-13.8 9.8-17.5 10.9-5.5 1.5-12.9.4-17 .3-3.8 1.5-9.5 4.6-10.6 11.5-1.1 6.7 5.3 15.6-.8 21.099-6.1 5.5-10.4 7.3-14.6 14.5-.3 8.7 5.4 17.4 14.1 21.4 9.2 4.3 24 2.9 33.1-8.8 12.9-16.7 6.6-32.4 5.1-34.8-3.1-4.6-.7-9 3.7-5.9z"
      fill="#28362C"
    />
    <path
      d="M86.947 68.9s-15.7-15.3-29.3-3.1c-9.9 8.9-7.1 10-15.5 11.3-7.1 1.1-16.4 2-16 10.9.4 8.9 7.3 14.899.4 21.499-6.9 6.7-13.5 4-13.5 19.3"
      stroke="#3C5749"
      strokeWidth={0.4}
      strokeMiterlimit={10}
    />
    <path
      d="M49.047 118.099c-6.1 1.4-14.6 18.1-15.1 19.8-.2.5-.3 1.8-.4 3.7 8.1.4 17.3-2.8 23.7-11 2.3-3 4-5.8 5.2-8.6-7.2-1.3-13.4-3.9-13.4-3.9z"
      fill="#28362C"
    />
    <path
      d="M86.947 69.5c-1.7 0-8.2-1.4-15.3 11.9-3.1 5.9-14-2.6-19.7 7.1-4.4 7.5 5.4 19.999 2.4 31.499-3.5 13.7-21.1 21.3-21.7 21.5"
      stroke="#3C5749"
      strokeWidth={0.4}
      strokeMiterlimit={10}
    />
    <path
      d="M16.947 249.5h265.8"
      stroke="#3C5749"
      strokeWidth={0.5}
      strokeMiterlimit={10}
    />
  </Svg>
)

export default PickupAndDropoff
